<template>
    <!-- 数据异常记录 -->
    <div class="abnormalPage">
        <section class="layout">
            <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" @confirmFn="confirmFn" @resetFn="resetFn" @searchFn="confirmFn"></v-search>

            <div class="componentPage">
                <v-table :tableData="tableData" :disabledLoad="disabledLoad" :loading="loading" @choozeTable="choozeTable" @handleRow="handleRow" v-bind="$attrs"></v-table>
            </div>
        </section>
        <handleDialog v-if="isShow" :isShow.sync="isShow" :title="title" :ReasonparamData="ReasonparamData" :rowData="rowData" @updateRow="updateRow" />
    </div>
</template>

<script>
import { getReasons } from '@/api/api.js';
import { exList } from '@/api/modules/abnormal.js';
import bus from '@/utils/bus.js';
import table from './Table.vue';
import handleDialog from '@/pages/abnormal/component/dialog/handleDialog.vue';
// import handle from './HandleModal.vue'
export default {
    props: ['detailObj'],
    components: {
        'v-table': table,
        handleDialog
        // "v-handle": handle,
    },
    data() {
        return {
            SearchForm: {
                carrierName: null,
                handle: null,
                status: '',
                time: [],
                iDisplayLength: 100,
                iDisplayStart: 0
            },
            formContent: [
                {
                    id: 2,
                    text: 'public.time',
                    type: 'datetimerange',
                    paramsName: 'time',
                    isChooze: true
                },
                {
                    id: 1,
                    text: 'public.table_carrier_name',
                    type: 'input',
                    paramsName: 'carrierName',
                    isChooze: false
                },

                {
                    id: 4,
                    text: 'public.status',
                    type: 'select',
                    paramsName: 'status',
                    isChooze: false,
                    selectParam: [
                        {
                            value: '',
                            label: 'public.please'
                        },
                        {
                            value: 0,
                            label: 'selectMsg.Closed Not'
                        },
                        {
                            value: 1,
                            label: 'selectMsg.Closed'
                        }
                    ]
                },
                {
                    id: 5,
                    text: 'public.Processed',
                    type: 'select',
                    paramsName: 'handle',
                    isChooze: false,
                    selectParam: [
                        {
                            value: '',
                            label: 'public.please'
                        },
                        {
                            value: 0,
                            label: 'selectMsg.Unprocessed'
                        },
                        {
                            value: 1,
                            label: 'selectMsg.Processed'
                        }
                    ]
                }
            ],
            tableData: [],
            loading: false,
            total: 0,
            choozeTableArray: [],
            title: '',
            noMore: true,
            loadings: false,
            /** 原因数据集合 */
            reasonArray: [],
            // 2022 11 21 处理数据弹窗
            isShow: false,
            title: '',
            // 设备集合
            ReasonparamData: [],
            // 点击的行数据
            rowData: {}
        };
    },
    computed: {
        i18n() {
            return this.$i18n.locale;
        },
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return currentUser.sysScope && currentUser.sysAdmin;
        },
        disabledLoad: {
            get: function() {
                return this.noMore;
            },
            set(val) {
                return val;
            }
        }
    },
    created() {
        this.getListFn(this.SearchForm);
        if (!this.isSysAdmin) {
            this.formContent.pop();
        }
    },
    mounted() {
        // 接收处理成功之后的回调
        this.searchRegionFns();
    },
    methods: {
        searchRegionFns() {
            bus.$on('searchRegionFn', row => {
                this.tableData.forEach(item => {
                    if (item.id === row.id) {
                        item.process += 1;
                        item.processTime = row.time;
                    }
                });
            });
        },
        getListFn(param = this.SearchForm) {
            this.loading = true;
            param.carrierName = this.detailObj['keycode'];
            var Query = { ...param };
            if (Query.time && Query.time.length > 0) {
                Query.from = this.$dateParseTime(new Date(Query.time[0]));
                Query.to = this.$dateParseTime(new Date(Query.time[1]));
                delete Query.time;
            }

            exList(Query)
                .then(({ result }) => {
                    this.loadings = false;
                    this.tableData = this.tableData.concat(result);
                    if (result.length === 0 || this.tableData.length < 100) {
                        this.noMore = true;
                    } else {
                        this.noMore = false;
                    }

                    // 首次请求  时间填充
                    // let endTime = this.$timetransition(this.tableData[0].happenTime);
                    // let startTime = this.$timetransition(this.tableData[this.tableData.length - 1].happenTime);
                    // this.SearchForm['time'] = [startTime, endTime]
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /** 确认查询 */
        confirmFn(params) {
            this.tableData = [];
            this.getListFn(params);
        },
        /** 重置 */
        resetFn() {
            this.SearchForm = {
                carrierName: null,
                state: null,
                status: null,
                from: null,
                to: null,
                scopeName: null,
                iDisplayLength: 100,
                iDisplayStart: 0
            };
            this.getListFn(this.SearchForm);
        },

        /** 勾选表格的数据 */
        choozeTable(arg) {
            this.choozeTableArray = arg;
        },

        handleRow(row) {
            this.isShow = true;
            this.title = `[${row.orgPath}/${row.carrierName}]-[${this.$timetransition(row.happenTime)}]-异常处理`;
            this.rowData = { ...row };
        },
        updateRow(info) {
            // bus.$on('searchRegionFn', row => {
            this.tableData.forEach(item => {
                if (item.id === info.id) {
                    item.process += 1;
                    item.processTime = info.time;
                }
            });
            // })
        }
    }
};
</script>

<style lang="scss" scoped>
.abnormalPage {
    box-sizing: border-box;
    height: 100%;

    .layout {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;

        ::v-deep .el-form--inline {
            padding-top: 0 !important;
        }
    }

    .componentPage {
        flex: 1;
        height: 100%;
        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
